export default __webpack_public_path__ + "static/media/grappa.57324ee6.png";